import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { Size } from '../../constants/size.js';
import { twMerge } from '../../utils/twMerge.js';
import { DescriptionListItemContext } from './DescriptionListItem/DescriptionListItem.js';
export const DescriptionList = forwardRef(function DescriptionList({ size = Size.Default, columns, ...dlProps }, forwardedRef) {
    const contextValue = useMemo(() => ({
        size,
        column: !!columns,
    }), [size, columns]);
    return (_jsx("dl", { ...dlProps, ref: forwardedRef, className: twMerge('ppl-DescriptionList', 'grid gap-x-6', size === Size.Default && !columns ? 'gap-y-0' : 'gap-y-2', 
        // It's not possible to use string interpolation with Tailwind https://v2.tailwindcss.com/docs/just-in-time-mode
        { 1: 'grid-cols-1', 2: `grid-cols-2`, 3: 'grid-cols-3' }[columns ?? 1], dlProps.className), children: _jsx(DescriptionListItemContext.Provider, { value: contextValue, children: dlProps.children }) }));
});
//# sourceMappingURL=DescriptionList.js.map